export function setLanguage(value) {
	return function(dispatch){
		dispatch({
			type: "SET_LANGUAGE",
			payload: value
		});

		localStorage.setItem('favoriteLanguage', value);
	}
}

export function isLanguagesListShown(boolean) {
	return {
		type: "IS_LANGUAGES_LIST_SHOWN",
		payload: boolean
	}
}
